import { useMemo } from "react";

import { isProduction } from "@citrine/configuration";
import { useConfiguration } from "@citrine/resources/configuration";
import type { DataFullstoryId } from "@citrine/types/full-story";

const loadFullStory = () => import("./full-story");

type EventProperties = Record<string, any>;

declare module "react" {
  interface HTMLAttributes<T>
    extends React.AriaAttributes, React.DOMAttributes<T> {
    "data-fullstoryid"?: DataFullstoryId;
  }
}

export function useEvent(): (
  eventId: DataFullstoryId,
  eventProperties?: EventProperties,
) => Promise<void>;
export function useEvent(
  eventId: DataFullstoryId,
): (eventProperties?: EventProperties) => Promise<void>;
export function useEvent(eventId?: DataFullstoryId) {
  const enableFullStory = useConfiguration("enableFullStory");

  return useMemo(() => {
    async function event(
      _eventId: DataFullstoryId,
      eventProperties: EventProperties = {},
    ) {
      if (isProduction && enableFullStory) {
        const FullStory = await loadFullStory();
        return FullStory.event(_eventId, eventProperties);
      }
    }

    return eventId ? event.bind(null, eventId) : event;
  }, [enableFullStory, eventId]);
}
